var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"headers":_vm.journeyTable.headers,"items":_vm.journeys,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('journey-table-row',{attrs:{"item":props,"is-active":_vm.isJourneyActive(props)},on:{"redirect-journey":_vm.redirectToJourney}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }